import React, { memo } from "react";
import { useFormik } from "formik";

import { useFilteredData } from "../../Hooks";
import { dateFormat } from "../../helper/common";
import { Label, CustomSelect, Button, DateRangePicker } from "../";

const MarketFilter = ({
  isSport = false,
  isTournament = false,
  isMatch = false,
  allMatch = false,
  handleFilterParams,
  apiParam,
  defaultParams = {},
  isBulkOperation = false,
  isType = false,
  marketTypeData = [],
  isDate = false,
  handleShowHide,
}) => {
  const { values, touched, errors, handleSubmit, setFieldValue, resetForm } =
    useFormik({
      initialValues: {
        sports: null,
        tournament: null,
        match: null,
        marketType: null,
        startDate: null,
        endDate: null,
      },
      enableReinitialize: true,
      onSubmit: async (values) => {
        const startDate = values?.startDate
          ? dateFormat(values?.startDate).formattedDate
          : null;
        const endDate = values?.endDate
          ? dateFormat(values?.endDate).formattedDate
          : null;
        const payload = {
          ...values,
          startDate,
          endDate,
        };
        handleFilterParams(payload);
      },
    });

  const { sportOptions, tournamentOptions, matchOptions } = useFilteredData({
    sport: values?.sports?.value,
    tournament: values?.tournament?.value,
    dependantMatch: isMatch,
    allMatch,
    enableTournament: isTournament,
    apiParam,
    isType,
  });

  const handleClear = () => {
    resetForm({
      values: {
        sports: null,
        tournament: null,
        match: null,
      },
    });

    setFieldValue("sports", null);
    setFieldValue("tournament", null);
    setFieldValue("match", null);

    handleFilterParams({
      sports: null,
      tournament: null,
      match: null,
    });
  };

  return (
    <form className="filter_tableBox" onSubmit={handleSubmit}>
      <div className="row align-items-end">
        {isSport && (
          <div className="col-lg-2 col-md-6 col-12 m-0 p-1">
            <div className="input_control">
              <Label htmlFor="sports" className="form-label">
                Sports
                <span className="text-danger">*</span>
              </Label>
              <CustomSelect
                options={sportOptions}
                value={values.sports}
                onChange={(selectedOption) =>
                  setFieldValue("sports", selectedOption)
                }
                placeholder="Select Sports"
                isMulti={false}
              />
            </div>
          </div>
        )}

        {isTournament && (
          <div className="col-lg-2 col-md-6 col-12 m-0 p-1">
            <div className="input_control">
              <Label htmlFor="tournament" className="form-label">
                Tournament
                <span className="text-danger">*</span>
              </Label>
              <CustomSelect
                options={tournamentOptions}
                value={values.tournament}
                onChange={(selectedOption) =>
                  setFieldValue("tournament", selectedOption)
                }
                placeholder="Select Tournament"
                isMulti={false}
              />
            </div>
          </div>
        )}

        {isMatch && (
          <div className="col-lg-2 col-md-6 col-12 m-0 p-1">
            <div className="input_control">
              <Label htmlFor="match" className="form-label">
                Matches
                <span className="text-danger">*</span>
              </Label>
              <CustomSelect
                options={matchOptions}
                value={values.match}
                onChange={(selectedOption) =>
                  setFieldValue("match", selectedOption)
                }
                placeholder="Select Match"
                isMulti={false}
              />
            </div>
          </div>
        )}

        {isType && marketTypeData && (
          <div className="col-lg-2 col-md-6 col-12 m-0 p-1">
            <div className="input_control">
              <Label htmlFor="marketType" className="form-label">
                Type
                <span className="text-danger">*</span>
              </Label>
              <CustomSelect
                options={marketTypeData}
                value={values.marketType}
                onChange={(selectedOption) =>
                  setFieldValue("marketType", selectedOption)
                }
                placeholder="Select marketType"
                isMulti={false}
              />
            </div>
          </div>
        )}

        {isDate && (
          <DateRangePicker
            values={values}
            setFieldValue={setFieldValue}
            className="col-lg-2 col-md-6 col-6 m-0 p-1"
          />
        )}

        <div className="col-xl-2 col-lg-4 col-12  ">
          <div className="btn_box">
            <Button type="submit" className="btn_submit">
              {" "}
              Search
            </Button>
            <Button type="button" className="btn_clear" onClick={handleClear}>
              Clear
            </Button>
        
          </div>
          
        </div>
         <div className="col-xl-1 col-lg-4 col-12  ">
            <div className="btn_box">
              <Button
                type="button"
                className="btn_submit"
                onClick={handleShowHide}
              >
                Bulk Operation
              </Button>
            </div>
          </div>
      </div>
    </form>
  );
};

export default memo(MarketFilter);
